// SUPER-LOT 104 — Moteur d'amortissement d'emprunts (3 méthodes, mathématiquement exact).
const num = (v) => Number(String(v ?? "").replace(/[^\d.-]/g, "")) || 0;

export const AMORT_METHODES = [
    ["echeance_constante", "Échéance constante (annuité)"],
    ["amortissement_constant", "Amortissement constant"],
    ["in_fine", "In Fine"],
];
export const labelMethode = (m) => (AMORT_METHODES.find(([v]) => v === m) || AMORT_METHODES[0])[1];

/** Échéancier mensuel d'UN emprunt. Retourne [{k, capital, interets, echeance, crd_debut, crd_fin}]. */
export function loanSchedule(loan) {
    const montant = num(loan.montant);
    const n = Math.max(0, Math.round(num(loan.duree_mois)));
    const i = num(loan.taux) / 100 / 12; // taux périodique mensuel
    const methode = loan.methode || "echeance_constante";
    if (!montant || !n) return [];
    const rows = [];
    let crd = montant;
    if (methode === "amortissement_constant") {
        const cap = montant / n; // capital remboursé fixe
        for (let k = 0; k < n; k++) {
            const interets = crd * i; // intérêts sur capital restant dû
            rows.push({ k, capital: cap, interets, echeance: cap + interets, crd_debut: crd, crd_fin: crd - cap });
            crd -= cap;
        }
    } else if (methode === "in_fine") {
        for (let k = 0; k < n; k++) {
            const interets = montant * i; // intérêts constants sur le capital total
            const last = k === n - 1;
            const capital = last ? montant : 0; // capital soldé à la dernière échéance
            rows.push({ k, capital, interets, echeance: capital + interets, crd_debut: montant, crd_fin: last ? 0 : montant });
        }
    } else { // échéance constante (annuité) : m = C·i / (1 − (1+i)^−n)
        const mensualite = i > 0 ? (montant * i) / (1 - Math.pow(1 + i, -n)) : montant / n;
        for (let k = 0; k < n; k++) {
            const interets = crd * i;
            const capital = mensualite - interets;
            rows.push({ k, capital, interets, echeance: mensualite, crd_debut: crd, crd_fin: crd - capital });
            crd -= capital;
        }
    }
    return rows;
}

/** Totaux d'un emprunt (pour l'affichage récapitulatif). */
export function loanTotals(loan) {
    const sched = loanSchedule(loan);
    const interets = sched.reduce((s, r) => s + r.interets, 0);
    const capital = sched.reduce((s, r) => s + r.capital, 0);
    const mensualite = sched.length ? sched[0].echeance : 0;
    return { interets, capital, cout_total: interets + capital, mensualite, n: sched.length };
}

/** Agrège TOUS les emprunts par clé calendaire "YYYY-MM" à partir de la 1ère échéance de chaque prêt.
 *  Retourne { [ym]: {capital, interets, echeance} } pour la ventilation Trésorerie (échéance) et P&L (intérêts). */
export function empruntsByMonth(emprunts, monthKeys) {
    const out = {};
    for (const mk of monthKeys) out[mk] = { capital: 0, interets: 0, echeance: 0 };
    for (const loan of emprunts || []) {
        const start = loan.date_premiere_echeance;
        if (!start) continue;
        const d = new Date(start);
        if (isNaN(d)) continue;
        const base = new Date(d.getFullYear(), d.getMonth(), 1);
        for (const r of loanSchedule(loan)) {
            const m = new Date(base.getFullYear(), base.getMonth() + r.k, 1);
            const ym = `${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, "0")}`;
            if (out[ym]) { out[ym].capital += r.capital; out[ym].interets += r.interets; out[ym].echeance += r.echeance; }
        }
    }
    return out;
}
